import React from 'react';
import { SimpleButton, ErrorMessage } from '@/src/ui';

type Mode = 'new' | 'edit';

interface PointLabelPopupProps {
    left: number;
    top: number;
    width: number;
    labelDraft: string;
    setLabelDraft: (v: string) => void;
    allowedLabels: string[];
    mode: Mode;
    onSave: () => void;
    onCancel: () => void;
    onRemove?: () => void;
}

export default function PointLabelPopup({
    left,
    top,
    width,
    labelDraft,
    setLabelDraft,
    allowedLabels,
    mode,
    onSave,
    onCancel,
    onRemove,
}: PointLabelPopupProps) {
    const stopAll = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <div
            style={{
                position: 'absolute',
                left,
                top,
                width,
                right: 'auto',
                zIndex: 10,
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.2)',
                borderRadius: 4,
                boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
                padding: '8px 12px',
                minWidth: 160,
                fontSize: 12,
                lineHeight: 1.4,
            }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={stopAll}
            onContextMenu={stopAll}
        >
            <div className="flex flex-col gap-2">
                <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Label</label>
                    <select
                        className={`border border-gray-300 rounded px-2 py-1 text-sm`}
                        value={labelDraft}
                        onChange={(e) => setLabelDraft(e.target.value)}
                    >
                        {!labelDraft && <option value="">Select label</option>}
                        {allowedLabels.map((lbl) => (
                            <option key={lbl} value={lbl}>
                                {lbl}
                            </option>
                        ))}
                    </select>
                    {allowedLabels.length === 0 && (
                        <ErrorMessage error={{ message: 'No available labels for this point.' }} />
                    )}
                </div>

                <div className="flex flex-row gap-2">
                    {mode === 'edit' && onRemove && (
                        <SimpleButton
                            type="button"
                            color="error"
                            variant="outlined"
                            className="text-[11px] px-2 py-1"
                            onClick={(e) => {
                                stopAll(e);
                                onRemove();
                            }}
                        >
                            Remove
                        </SimpleButton>
                    )}
                    <SimpleButton
                        type="button"
                        color="primary"
                        className="bg-blue-600 text-white text-[11px] px-2 py-1 rounded"
                        onClick={(e) => {
                            stopAll(e);
                            onSave();
                        }}
                        disabled={!labelDraft || allowedLabels.length === 0}
                    >
                        Save
                    </SimpleButton>
                    <SimpleButton
                        type="button"
                        color="secondary"
                        variant="outlined"
                        className="text-[11px] px-2 py-1"
                        onClick={(e) => {
                            stopAll(e);
                            onCancel();
                        }}
                    >
                        Cancel
                    </SimpleButton>
                </div>
            </div>
        </div>
    );
}
